export const YEAR = "2026";
export const TIMING = "с 29 сентября по 2 октября 2026 года";
export const shortName = "УОМШ-26";
